import { render, staticRenderFns } from "./DZSVG2.vue?vue&type=template&id=0f939ab6&scoped=true"
import script from "./DZSVG2.vue?vue&type=script&lang=js"
export * from "./DZSVG2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f939ab6",
  null
  
)

export default component.exports